<template>
  <div class="flex-grow-1">
    <v-text-field
      :counter="counter"
      :data-cy="`${entityName}__textField--${attributeName}`"
      :disabled="disabled"
      :value="value"
      :rules="autoRules"
      @input="valueUpdate"
      outlined
    ></v-text-field>
  </div>
</template>

<script>
export default {
  computed: {
    counterValue() {
      if (this.counter) return parseInt(this.counter, 10);
      return null;
    },
    hideDetails() {
      return !this.hasConflict;
    },
    autoRules() {
      const auto = [
        v => !!v || !this.required || "Required Field",
        v =>
          !this.checkForConflicts(v) ||
          `Another ${this.entityName} has the same value. Please enter a unique value.`,
      ];
      if (this.counterValue) {
        auto.unshift(
          v =>
            `${v}`.length <= this.counterValue ||
            `This field has a maximum character count of ${this.counterValue}`
        );
      }
      if (this.rules && this.rules.length) {
        return this.rules.concat(auto);
      }
      return auto;
    },
  },
  data() {
    return {
      hasConflict: false,
    };
  },
  methods: {
    checkForConflicts(value) {
      if (!value) {
        this.hasConflict = false;
        return false;
      }

      const conflict = this.list.find(item => {
        return (
          `${item[this.attributeName]}`.trim().toUpperCase() ===
            `${value}`.trim().toUpperCase() &&
          item[`${this.entityName}Id`] !== this.entityIdValue
        );
      });
      if (conflict) {
        this.hasConflict = true;
        return true;
      }
      this.hasConflict = false;
      return false;
    },
    getRequiredIfValue(attribute) {
      return this.entityRecord[attribute];
    },
    valueUpdate(value) {
      const conflicts = this.checkForConflicts(value);
      if (!conflicts) this.$emit("input", value);
    },
  },
  notifications: {
    notifyError: {
      title: "Error",
      type: "error",
    },
  },
  props: {
    attributeName: { required: false },
    counter: { required: false },
    disabled: { type: Boolean },
    entityIdValue: { required: false },
    entityName: { required: false },
    list: { required: false },
    required: { required: false },
    rules: { required: false, type: Array },
    value: { required: false },
  },
};
</script>
